import { render, staticRenderFns } from "./TagsEditor.vue?vue&type=template&id=1d259638"
import script from "./TagsEditor.vue?vue&type=script&lang=ts"
export * from "./TagsEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports